module.exports = __webpack_public_path__ + "img/carrousel-mamo-7.f20dc363.jpg";